import user from './user.api'
import auth from './auth.api'
import restrictions from './restrictions.api'
import crop from './crop.api'
import labs from './labs.api'
import file from './file.api'
import fields from './fields.api'
import misc from './misc.api'
import satellite from './satellite.api'
import program from './program.api'
import TexturesAPI from './textures.api'
import SoilTestAPI from './tests/soil-test.api'
import WaterTestAPI from './tests/water-test.api'
import TissueTestAPI from './tests/tissue-test.api'
import MediaAnalysisAPI from './tests/media-analysis.api'
import PlansAPI from './plans.api'
import QuickRegAPI from './quick-reg.api'
import fertilizers from './fertilizers.api'
import pdf from './pdf.api'
import tickets from './tickets.api'
import CouponsAPI from './coupons.api'
import { TopUpsAPI } from './top-ups.api'
import map from './map.api'
import reports from './reports.api'
import announs from './announs.api'
import drainage from './drainage.api'
import subAccounts from './subAccounts.api'
import market from './market.api'

export default {
  user: user,
  auth: auth,
  crop: crop,
  file: file,
  reports: reports,
  restrictions: restrictions,
  labs: labs,
  fields: fields,
  misc: misc,
  satellite: satellite,
  program: program,
  fertilizers: fertilizers,
  TexturesAPI: TexturesAPI,
  SoilTestAPI : SoilTestAPI,
  MediaAnalysisAPI : MediaAnalysisAPI,
  pdf: pdf,
  tickets: tickets,
  map: map,
  announs: announs,
  subAccounts: subAccounts,
  drainage: drainage,

}

// потом перейдем на такой формат
export {
  auth as AuthAPI,
  tickets as TicketsAPI,
  file as FileAPI,
  crop as CropAPI,
  TexturesAPI,
  labs as LabsAPI,
  SoilTestAPI,
  WaterTestAPI,
  TissueTestAPI,
  program as ProgramAPI,
  PlansAPI,
  QuickRegAPI,
  user as UserAPI,
  CouponsAPI,
  satellite as SatelliteAPI,
  market as MarketAPI,
  drainage as DrainageAPI,
  MediaAnalysisAPI
}
